// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__242V4","toggle":"styles_toggle__1rDkJ","preview":"styles_preview__3V11O"};